<div class="org-admin-dashboard" *ngIf="!isChecking">
  <div class="org-admin-dashboard--layout" *ngIf="canAccess">
    <app-org-admin-sidebar class="org-admin-dashboard--sidebar"></app-org-admin-sidebar>
    <div class="org-admin-dashboard--content">
      <div class="page-container">
        <app-dataset-provider-dashboard></app-dataset-provider-dashboard>
      </div>
    </div>
  </div>
</div>
